var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLayoutIcon = function SvgLayoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.879.879.293 4.465a1 1 0 0 0 0 1.414l6.5 6.5 4.793-4.793c.07-.07.144-.135.222-.192L9.293 4.879l-1.5 1.5a1 1 0 1 1-1.414-1.414l1.5-1.5L5.293.879a1 1 0 0 0-1.414 0Zm7.914 16.5L9.62 15.207l4.793-4.793c.07-.07.135-.144.192-.222l2.202 2.202a2.02 2.02 0 0 0-.222.192l-4.793 4.793Zm7.621-1.965c.07-.07.134-.144.192-.222l2.273 2.273-1.5 1.5a1 1 0 0 0 1.414 1.414l1.5-1.5 3.586 3.586a1 1 0 0 1 0 1.414l-3.586 3.586a1 1 0 0 1-1.414 0l-7.258-7.258 4.793-4.793Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.793 3.879 23.207.293a1 1 0 0 0-1.414 0l-3.086 3.086 5 5 3.086-3.086a1 1 0 0 0 0-1.414Zm-4.5 5.914-5-5-17 17A1 1 0 0 0 0 22.5v3.586a1 1 0 0 0 1 1h3.586a1 1 0 0 0 .707-.293l17-17Z",
    fill: "currentColor"
  })));
};
export default SvgLayoutIcon;